module.exports = __webpack_public_path__ + "@/assets/img/coins.dfb29055.png";